import { Button, MenuItem } from '@mui/material'
import EmailIcon from '@mui/icons-material/Email'

import { useIsLargeScreen } from '@/hooks/useIsLargeScreen'

type OpenMSSanteProps = {
  patientId: string
  onClose?: () => void
}

export function OpenMSSante({ patientId, onClose }: OpenMSSanteProps) {
  const isLargeScreen = useIsLargeScreen()

  const handleClick = () => {
    window.open(`/efficience-web?patientId=${patientId}&mode=mss`, '_blank')
    onClose?.()
  }

  if (isLargeScreen) {
    return (
      <Button startIcon={<EmailIcon />} variant="contained" onClick={handleClick}>
        MS Santé
      </Button>
    )
  }

  return (
    <MenuItem onClick={handleClick} disableRipple>
      <EmailIcon />
      MS Santé
    </MenuItem>
  )
}
